import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { MessagesContainer } from '../../state/messages';
import { AlertMessages } from './AlertMessages';

export const FlashMessages = (): JSX.Element | null => {
	const [shouldClearMessages, setShouldClearMessages] = useState(false);
	const alerts = MessagesContainer.useContainer();
	const location = useLocation();

	useEffect(() => {
		if (shouldClearMessages) {
			alerts.clear();
			setShouldClearMessages(false);
		} else if (!shouldClearMessages) {
			setShouldClearMessages(true);
		}
	}, [location]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div id="flash-messages">
			<AlertMessages alerts={alerts} />
		</div>
	);
};
